import React, { useEffect, useState } from "react";
import {
  Avatar,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger
} from "@heroui/react";
import Bell from "../../../images/icon/bell.svg";
import NotificationCard from "./notification-card";
import { NotificationApi } from "../../../api/methods-marketplace";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const NotificationComponent = () => {
  const [notificationData, setNotificationData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  // const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const isLogin = user?.login;

  useEffect(() => {
    if (isLogin) {
      fetchNotificatioData();
    }
  }, [isLogin]);

  const fetchNotificatioData = async () => {
    // setIsLoading(true);
    try {
      const response = await NotificationApi();
      if (response) {
        const {
          data: { data }
        } = response;
        setNotificationData(data);
        // setIsLoading(false);
      }
    } catch (error) {
      // setIsLoading(false);
      console.error("Failed to fetch notification data:", error);
    } finally {
      // setIsLoading(false);
    }
  };

  // Get today's date in "YYYY-MM-DD" format
  const today = dayjs().format("YYYY-MM-DD");
  const todayNotifications = notificationData.reduce((acc, notification) => {
    if (dayjs(notification.created_at).format("YYYY-MM-DD") === today) {
      acc.push(notification);
    }
    return acc;
  }, []);

  const otherNotifications = notificationData.reduce((acc, notification) => {
    if (dayjs(notification.created_at).format("YYYY-MM-DD") !== today) {
      acc.push(notification);
    }
    return acc;
  }, []);

  return (
    <>
      <Dropdown
        placement="bottom-end"
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        classNames={{
          group: "flex flex-col gap-6 max-h-[30rem] h-full overflow-y-auto"
        }}
      >
        <DropdownTrigger className="!w-10 !h-10 min-w-10 max-w-10 min-h-10 rounded-lg bg-yellowbuy ring-0 ring-offset-0 ring-offset-none">
          <Avatar
            isBordered
            as="button"
            className="transition-transform !w-6 !h-6"
            classNames={{
              img: "!w-6 !h-6"
            }}
            src={Bell}
          />
        </DropdownTrigger>
        <DropdownMenu
          aria-label="Profile Actions"
          variant="flat"
          classNames={{
            list: "gap-6"
          }}
        >
          {notificationData?.length > 0 ? (
            <>
              <DropdownSection aria-label="notification-header">
                <DropdownItem
                  textValue="title"
                  key="title"
                  isReadOnly
                  classNames={{
                    base: "cursor-auto rounded-none data-[hover=true]:bg-[transparent] data-[hover=true]:text-default-foreground data-[selectable=true]:focus:bg-[transparent] data-[selectable=true]:focus:text-default-foreground"
                  }}
                >
                  <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-4">
                      <h1 className="m-0 text-2xl text-black font-bold w-[calc(100%-3rem)] font-sans">
                        Notification
                      </h1>
                    </div>
                    {todayNotifications?.length > 0 && (
                      <p className="m-0 text-xs text-black font-sans font-normal">
                        You have{" "}
                        <span className="font-bold">
                          {todayNotifications?.length} Notification
                          {todayNotifications?.length !== 1 ? "s" : ""}
                        </span>{" "}
                        Today
                      </p>
                    )}
                  </div>
                </DropdownItem>
              </DropdownSection>
              <DropdownSection
                aria-label="notification-body"
                classNames={{
                  group:
                    "flex flex-col gap-6 max-h-[30rem] h-full overflow-y-auto"
                }}
              >
                {todayNotifications?.length > 0 && (
                  <DropdownItem
                    textValue="first"
                    key="first-wrapper"
                    isReadOnly
                    classNames={{
                      base: "cursor-auto rounded-none data-[hover=true]:bg-[transparent] data-[hover=true]:text-default-foreground data-[selectable=true]:focus:bg-[transparent] data-[selectable=true]:focus:text-default-foreground"
                    }}
                  >
                    <div className="flex flex-col gap-5">
                      <h6 className="m-0 text-base text-black font-bold">
                        Today
                      </h6>
                      <div className="flex flex-col gap-2.5">
                        {todayNotifications &&
                          Array.isArray(todayNotifications) &&
                          todayNotifications?.map((item, index) => (
                            <NotificationCard
                              data={item}
                              key={index}
                              onClose={() => setIsOpen(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </DropdownItem>
                )}

                {otherNotifications?.length > 0 && (
                  <DropdownItem
                    textValue="second"
                    key="second-wrapper"
                    isReadOnly
                    classNames={{
                      base: "cursor-auto rounded-none data-[hover=true]:bg-[transparent] data-[hover=true]:text-default-foreground data-[selectable=true]:focus:bg-[transparent] data-[selectable=true]:focus:text-default-foreground"
                    }}
                  >
                    <div className="flex flex-col gap-5">
                      <h6 className="m-0 text-base text-black font-bold">
                        This Week
                      </h6>
                      <div className="flex flex-col gap-2.5">
                        {otherNotifications &&
                          Array.isArray(otherNotifications) &&
                          otherNotifications?.map((item, index) => (
                            <NotificationCard
                              data={item}
                              key={index}
                              onClose={() => setIsOpen(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </DropdownItem>
                )}
              </DropdownSection>
            </>
          ) : (
            <>
              <DropdownSection aria-label="notification-header-loading">
                <DropdownItem
                  textValue="title-loading"
                  key="title-loading"
                  isReadOnly
                  classNames={{
                    base: "cursor-auto rounded-none data-[hover=true]:bg-[transparent] data-[hover=true]:text-default-foreground data-[selectable=true]:focus:bg-[transparent] data-[selectable=true]:focus:text-default-foreground"
                  }}
                >
                  <div className="flex flex-col items-center justify-center gap-2 p-3">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-gray-400"
                    >
                      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                    <h1 className="text-lg font-medium text-gray-700">
                      No Notifications
                    </h1>
                    <p className="text-sm text-gray-500">
                      You're all caught up!
                    </p>
                  </div>
                </DropdownItem>
              </DropdownSection>
            </>
          )}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default NotificationComponent;
